import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import type { Popup } from "@schemas/popup";

import { cookieStorage } from "@utils/cookieStorage";

import { ModalClose } from "../Items";

import "swiper/css";
import "swiper/css/pagination";

import "./style.scss";

interface MobilePopupSwiperProps {
	popups: Popup[];
	onClose?: () => void;
	aspectRatio?: string;
}

export default function MobilePopupSwiper({
	popups,
	onClose,
	aspectRatio = "16 / 9",
}: MobilePopupSwiperProps) {
	const handleHideToday = () => {
		cookieStorage.set("popup-hide-all", "1", { days: 1 });
		onClose?.();
	};

	return (
		<div className="popup-modal popup-mobile" role="dialog" aria-modal="true">
			<button className="popup-modal__close" aria-label="닫기" onClick={onClose}>
				<ModalClose />
			</button>

			<div className="popup-mobile__ratio" style={{ aspectRatio }}>
				<Swiper
					modules={[Pagination]}
					pagination={{ clickable: true }}
					loop
					className="popup-mobile__swiper"
				>
					{popups.map((p) => {
						const target = p.shouldOpenInNewTab ? "_blank" : "_self";
						return (
							<SwiperSlide key={p.id} className="popup-mobile__slide">
								<a
									href={p.imageLink}
									target={target}
									rel={p.shouldOpenInNewTab ? "noopener noreferrer" : undefined}
								>
									<img draggable={false} src={p.imageUrl} alt="popup" />
								</a>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>

			<div className="popup-modal__footer">
				<button className="hide-today" onClick={handleHideToday}>
					오늘 하루 보지 않기
				</button>
			</div>
		</div>
	);
}
